import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "exports-container" }
const _hoisted_2 = { class: "exports-container__header" }
const _hoisted_3 = { class: "exports-container__description" }
const _hoisted_4 = { class: "exports-container__content" }

import { watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import type { RouteLocationNormalized } from 'vue-router';

import { getFromQuery } from '@exchange/helpers/query-param-to-string';
import { exportsService } from '@exchange/libs/exports/service/src';

import ExportTable from './components/ExportTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportsContainer',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { fetchingList, fetchingListError, list, showNewExportModal, fetchExportListsNow, fetchExportItem, downloadExportItem } = exportsService;

const handleExportEmailLinks = async (r: RouteLocationNormalized) => {
  const exportId = getFromQuery('export_id', r.query);

  if (!exportId || !list.value.length) {
    return;
  }

  const item = list.value.find((i) => i.id === exportId);

  if (!item) {
    return;
  }

  await downloadExportItem(exportId);
  await router.replace({ name: 'exports' });
};

watch(
  route,
  async (r) => {
    if (!list.value.length) {
      return;
    }

    await fetchExportListsNow();

    await handleExportEmailLinks(r);
  },
  { immediate: true },
);

fetchExportListsNow();

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('modules.exports.page.description')), 1),
      _createVNode(_component_x_button, {
        class: "exports-container__action",
        size: "sm",
        variant: "primary",
        text: _ctx.$t('modules.exports.page.newExport'),
        onClick: _unref(showNewExportModal)
      }, null, 8, ["text", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(ExportTable, {
        list: _unref(list),
        error: _unref(fetchingListError),
        loading: _unref(fetchingList),
        "fetch-list": _unref(fetchExportListsNow),
        "fetch-item": _unref(fetchExportItem),
        "download-item": _unref(downloadExportItem)
      }, null, 8, ["list", "error", "loading", "fetch-list", "fetch-item", "download-item"])
    ])
  ]))
}
}

})